const localeReplacementTable = {
  pt: 'es',
  it: 'fr',
  ja: 'es',
  zh: 'fr',
  ar: 'es',
  tr: 'fr',
  de: 'de',
  ca: 'fr',
};

export default localeReplacementTable;
